module.exports = __webpack_public_path__ + "img/vx.2b5cabd6.jpg";